import DataSelector from '../components/App';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {changeMode, changeViewMode} from '../actions';
import { StoreState } from '../types';


// 将 reducer 中的状态插入到组件的 props 中
const mapStateToProps = (state: StoreState) => ({
    mode_id: state.mode_id, 
    view_mode : state.view_mode
})

// 将 对应action 插入到组件的 props 中
const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeMode: (mode_id: number) => dispatch(changeMode(mode_id)),
    changeViewMode: (view_mode:number) => dispatch(changeViewMode(view_mode))
})

// 使用 connect 高阶组件对 Counter 进行包裹
export default connect(mapStateToProps, mapDispatchToProps)(DataSelector);
